module.exports = __webpack_public_path__ + "static/media/image1.35dc21de.jpg";